import { render, staticRenderFns } from "./InspectionController.vue?vue&type=template&id=4ac543f2&"
import script from "./InspectionController.vue?vue&type=script&lang=js&"
export * from "./InspectionController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports